import React from "react"

export const UncacheableImg = ({ src, alt, className }: { src: string, alt: string, className?: string }) => {
  const portalLogoHash = Date.now()

  return <img className={className} src={`${src}?${portalLogoHash}`} alt={alt} />
}
